import Ht, { isAxiosError as Gr } from "axios";
import { useMemo as Kr } from "react";
var ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ne(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $ = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, qr = $, G = !qr(function() {
  var t = (function() {
  }).bind();
  return typeof t != "function" || t.hasOwnProperty("prototype");
}), Wt = G, zt = Function.prototype, je = zt.call, Hr = Wt && zt.bind.bind(je, je), m = Wt ? Hr : function(t) {
  return function() {
    return je.apply(t, arguments);
  };
}, Wr = m, K = Wr({}.isPrototypeOf), Y = function(t) {
  return t && t.Math === Math && t;
}, T = (
  // eslint-disable-next-line es/no-global-this -- safe
  Y(typeof globalThis == "object" && globalThis) || Y(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Y(typeof self == "object" && self) || Y(typeof ce == "object" && ce) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ (function() {
    return this;
  })() || ce || Function("return this")()
), zr = G, Yt = Function.prototype, tt = Yt.apply, rt = Yt.call, Yr = typeof Reflect == "object" && Reflect.apply || (zr ? rt.bind(tt) : function() {
  return rt.apply(tt, arguments);
}), Jt = m, Jr = Jt({}.toString), Xr = Jt("".slice), ae = function(t) {
  return Xr(Jr(t), 8, -1);
}, Zr = ae, Qr = m, Ge = function(t) {
  if (Zr(t) === "Function") return Qr(t);
}, Me = typeof document == "object" && document.all, en = typeof Me > "u" && Me !== void 0, Xt = {
  all: Me,
  IS_HTMLDDA: en
}, Zt = Xt, tn = Zt.all, _ = Zt.IS_HTMLDDA ? function(t) {
  return typeof t == "function" || t === tn;
} : function(t) {
  return typeof t == "function";
}, Qt = {}, rn = $, q = !rn(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), nn = G, J = Function.prototype.call, Ke = nn ? J.bind(J) : function() {
  return J.apply(J, arguments);
}, er = {}, tr = {}.propertyIsEnumerable, rr = Object.getOwnPropertyDescriptor, an = rr && !tr.call({ 1: 2 }, 1);
er.f = an ? function(e) {
  var r = rr(this, e);
  return !!r && r.enumerable;
} : tr;
var nr = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, on = m, sn = $, cn = ae, ue = Object, un = on("".split), ar = sn(function() {
  return !ue("z").propertyIsEnumerable(0);
}) ? function(t) {
  return cn(t) === "String" ? un(t, "") : ue(t);
} : ue, or = function(t) {
  return t == null;
}, ln = or, dn = TypeError, oe = function(t) {
  if (ln(t)) throw dn("Can't call method on " + t);
  return t;
}, fn = ar, pn = oe, ir = function(t) {
  return fn(pn(t));
}, nt = _, sr = Xt, vn = sr.all, M = sr.IS_HTMLDDA ? function(t) {
  return typeof t == "object" ? t !== null : nt(t) || t === vn;
} : function(t) {
  return typeof t == "object" ? t !== null : nt(t);
}, qe = {}, le = qe, de = T, hn = _, at = function(t) {
  return hn(t) ? t : void 0;
}, cr = function(t, e) {
  return arguments.length < 2 ? at(le[t]) || at(de[t]) : le[t] && le[t][e] || de[t] && de[t][e];
}, gn = typeof navigator < "u" && String(navigator.userAgent) || "", ur = T, fe = gn, ot = ur.process, it = ur.Deno, st = ot && ot.versions || it && it.version, ct = st && st.v8, y, re;
ct && (y = ct.split("."), re = y[0] > 0 && y[0] < 4 ? 1 : +(y[0] + y[1]));
!re && fe && (y = fe.match(/Edge\/(\d+)/), (!y || y[1] >= 74) && (y = fe.match(/Chrome\/(\d+)/), y && (re = +y[1])));
var mn = re, ut = mn, yn = $, _n = T, bn = _n.String, lr = !!Object.getOwnPropertySymbols && !yn(function() {
  var t = Symbol("symbol detection");
  return !bn(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && ut && ut < 41;
}), Sn = lr, dr = Sn && !Symbol.sham && typeof Symbol.iterator == "symbol", $n = cr, wn = _, Tn = K, xn = dr, En = Object, fr = xn ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  var e = $n("Symbol");
  return wn(e) && Tn(e.prototype, En(t));
}, kn = String, In = function(t) {
  try {
    return kn(t);
  } catch {
    return "Object";
  }
}, On = _, Dn = In, An = TypeError, He = function(t) {
  if (On(t)) return t;
  throw An(Dn(t) + " is not a function");
}, Pn = He, Rn = or, Cn = function(t, e) {
  var r = t[e];
  return Rn(r) ? void 0 : Pn(r);
}, pe = Ke, ve = _, he = M, Nn = TypeError, jn = function(t, e) {
  var r, n;
  if (e === "string" && ve(r = t.toString) && !he(n = pe(r, t)) || ve(r = t.valueOf) && !he(n = pe(r, t)) || e !== "string" && ve(r = t.toString) && !he(n = pe(r, t))) return n;
  throw Nn("Can't convert object to primitive value");
}, pr = { exports: {} }, lt = T, Mn = Object.defineProperty, Un = function(t, e) {
  try {
    Mn(lt, t, { value: e, configurable: !0, writable: !0 });
  } catch {
    lt[t] = e;
  }
  return e;
}, Fn = T, Ln = Un, dt = "__core-js_shared__", Bn = Fn[dt] || Ln(dt, {}), vr = Bn, ft = vr;
(pr.exports = function(t, e) {
  return ft[t] || (ft[t] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Vn = pr.exports, Gn = oe, Kn = Object, hr = function(t) {
  return Kn(Gn(t));
}, qn = m, Hn = hr, Wn = qn({}.hasOwnProperty), ie = Object.hasOwn || function(e, r) {
  return Wn(Hn(e), r);
}, zn = m, Yn = 0, Jn = Math.random(), Xn = zn(1 .toString), Zn = function(t) {
  return "Symbol(" + (t === void 0 ? "" : t) + ")_" + Xn(++Yn + Jn, 36);
}, Qn = T, ea = Vn, pt = ie, ta = Zn, ra = lr, na = dr, P = Qn.Symbol, ge = ea("wks"), aa = na ? P.for || P : P && P.withoutSetter || ta, U = function(t) {
  return pt(ge, t) || (ge[t] = ra && pt(P, t) ? P[t] : aa("Symbol." + t)), ge[t];
}, oa = Ke, vt = M, ht = fr, ia = Cn, sa = jn, ca = U, ua = TypeError, la = ca("toPrimitive"), da = function(t, e) {
  if (!vt(t) || ht(t)) return t;
  var r = ia(t, la), n;
  if (r) {
    if (e === void 0 && (e = "default"), n = oa(r, t, e), !vt(n) || ht(n)) return n;
    throw ua("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), sa(t, e);
}, fa = da, pa = fr, gr = function(t) {
  var e = fa(t, "string");
  return pa(e) ? e : e + "";
}, va = T, gt = M, Ue = va.document, ha = gt(Ue) && gt(Ue.createElement), ga = function(t) {
  return ha ? Ue.createElement(t) : {};
}, ma = q, ya = $, _a = ga, mr = !ma && !ya(function() {
  return Object.defineProperty(_a("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), ba = q, Sa = Ke, $a = er, wa = nr, Ta = ir, xa = gr, Ea = ie, ka = mr, mt = Object.getOwnPropertyDescriptor;
Qt.f = ba ? mt : function(e, r) {
  if (e = Ta(e), r = xa(r), ka) try {
    return mt(e, r);
  } catch {
  }
  if (Ea(e, r)) return wa(!Sa($a.f, e, r), e[r]);
};
var Ia = $, Oa = _, Da = /#|\.prototype\./, H = function(t, e) {
  var r = Pa[Aa(t)];
  return r === Ca ? !0 : r === Ra ? !1 : Oa(e) ? Ia(e) : !!e;
}, Aa = H.normalize = function(t) {
  return String(t).replace(Da, ".").toLowerCase();
}, Pa = H.data = {}, Ra = H.NATIVE = "N", Ca = H.POLYFILL = "P", Na = H, yt = Ge, ja = He, Ma = G, Ua = yt(yt.bind), yr = function(t, e) {
  return ja(t), e === void 0 ? t : Ma ? Ua(t, e) : function() {
    return t.apply(e, arguments);
  };
}, _r = {}, Fa = q, La = $, Ba = Fa && La(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), Va = M, Ga = String, Ka = TypeError, qa = function(t) {
  if (Va(t)) return t;
  throw Ka(Ga(t) + " is not an object");
}, Ha = q, Wa = mr, za = Ba, X = qa, _t = gr, Ya = TypeError, me = Object.defineProperty, Ja = Object.getOwnPropertyDescriptor, ye = "enumerable", _e = "configurable", be = "writable";
_r.f = Ha ? za ? function(e, r, n) {
  if (X(e), r = _t(r), X(n), typeof e == "function" && r === "prototype" && "value" in n && be in n && !n[be]) {
    var a = Ja(e, r);
    a && a[be] && (e[r] = n.value, n = {
      configurable: _e in n ? n[_e] : a[_e],
      enumerable: ye in n ? n[ye] : a[ye],
      writable: !1
    });
  }
  return me(e, r, n);
} : me : function(e, r, n) {
  if (X(e), r = _t(r), X(n), Wa) try {
    return me(e, r, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw Ya("Accessors not supported");
  return "value" in n && (e[r] = n.value), e;
};
var Xa = q, Za = _r, Qa = nr, eo = Xa ? function(t, e, r) {
  return Za.f(t, e, Qa(1, r));
} : function(t, e, r) {
  return t[e] = r, t;
}, Z = T, to = Yr, ro = Ge, no = _, ao = Qt.f, oo = Na, O = qe, io = yr, D = eo, bt = ie, so = function(t) {
  var e = function(r, n, a) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new t();
        case 1:
          return new t(r);
        case 2:
          return new t(r, n);
      }
      return new t(r, n, a);
    }
    return to(t, this, arguments);
  };
  return e.prototype = t.prototype, e;
}, W = function(t, e) {
  var r = t.target, n = t.global, a = t.stat, o = t.proto, i = n ? Z : a ? Z[r] : (Z[r] || {}).prototype, s = n ? O : O[r] || D(O, r, {})[r], u = s.prototype, d, v, f, l, h, k, I, w, se;
  for (l in e)
    d = oo(n ? l : r + (a ? "." : "#") + l, t.forced), v = !d && i && bt(i, l), k = s[l], v && (t.dontCallGetSet ? (se = ao(i, l), I = se && se.value) : I = i[l]), h = v && I ? I : e[l], !(v && typeof k == typeof h) && (t.bind && v ? w = io(h, Z) : t.wrap && v ? w = so(h) : o && no(h) ? w = ro(h) : w = h, (t.sham || h && h.sham || k && k.sham) && D(w, "sham", !0), D(s, l, w), o && (f = r + "Prototype", bt(O, f) || D(O, f, {}), D(O[f], l, h), t.real && u && (d || !u[l]) && D(u, l, h)));
}, co = Math.ceil, uo = Math.floor, lo = Math.trunc || function(e) {
  var r = +e;
  return (r > 0 ? uo : co)(r);
}, fo = lo, br = function(t) {
  var e = +t;
  return e !== e || e === 0 ? 0 : fo(e);
}, po = br, vo = Math.max, ho = Math.min, go = function(t, e) {
  var r = po(t);
  return r < 0 ? vo(r + e, 0) : ho(r, e);
}, mo = br, yo = Math.min, Sr = function(t) {
  return t > 0 ? yo(mo(t), 9007199254740991) : 0;
}, _o = Sr, $r = function(t) {
  return _o(t.length);
}, bo = ir, So = go, $o = $r, wo = function(t) {
  return function(e, r, n) {
    var a = bo(e), o = $o(a), i = So(n, o), s;
    if (r !== r) {
      for (; o > i; )
        if (s = a[i++], s !== s) return !0;
    } else for (; o > i; i++)
      if (a[i] === r) return t;
    return !t;
  };
}, To = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: wo(!0)
}, xo = W, Eo = To.includes, ko = $, Io = ko(function() {
  return !Array(1).includes();
});
xo({ target: "Array", proto: !0, forced: Io }, {
  includes: function(e) {
    return Eo(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Oo = qe, z = function(t) {
  return Oo[t + "Prototype"];
}, Do = z, Ao = Do("Array").includes, Po = M, Ro = ae, Co = U, No = Co("match"), jo = function(t) {
  var e;
  return Po(t) && ((e = t[No]) !== void 0 ? !!e : Ro(t) === "RegExp");
}, Mo = jo, Uo = TypeError, wr = function(t) {
  if (Mo(t))
    throw Uo("The method doesn't accept regular expressions");
  return t;
}, Fo = U, Lo = Fo("toStringTag"), Tr = {};
Tr[Lo] = "z";
var Bo = String(Tr) === "[object z]", Vo = Bo, Go = _, Q = ae, Ko = U, qo = Ko("toStringTag"), Ho = Object, Wo = Q(/* @__PURE__ */ (function() {
  return arguments;
})()) === "Arguments", zo = function(t, e) {
  try {
    return t[e];
  } catch {
  }
}, xr = Vo ? Q : function(t) {
  var e, r, n;
  return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (r = zo(e = Ho(t), qo)) == "string" ? r : Wo ? Q(e) : (n = Q(e)) === "Object" && Go(e.callee) ? "Arguments" : n;
}, Yo = xr, Jo = String, Er = function(t) {
  if (Yo(t) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return Jo(t);
}, Xo = U, Zo = Xo("match"), kr = function(t) {
  var e = /./;
  try {
    "/./"[t](e);
  } catch {
    try {
      return e[Zo] = !1, "/./"[t](e);
    } catch {
    }
  }
  return !1;
}, Qo = W, ei = m, ti = wr, ri = oe, St = Er, ni = kr, ai = ei("".indexOf);
Qo({ target: "String", proto: !0, forced: !ni("includes") }, {
  includes: function(e) {
    return !!~ai(
      St(ri(this)),
      St(ti(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var oi = z, ii = oi("String").includes, $t = K, si = Ao, ci = ii, Se = Array.prototype, $e = String.prototype, ui = function(t) {
  var e = t.includes;
  return t === Se || $t(Se, t) && e === Se.includes ? si : typeof t == "string" || t === $e || $t($e, t) && e === $e.includes ? ci : e;
}, li = ui, di = li, fi = di, A = /* @__PURE__ */ ne(fi), pi = m, vi = pi([].slice), Ir = m, hi = He, gi = M, mi = ie, wt = vi, yi = G, Or = Function, _i = Ir([].concat), bi = Ir([].join), we = {}, Si = function(t, e, r) {
  if (!mi(we, e)) {
    for (var n = [], a = 0; a < e; a++) n[a] = "a[" + a + "]";
    we[e] = Or("C,a", "return new C(" + bi(n, ",") + ")");
  }
  return we[e](t, r);
}, $i = yi ? Or.bind : function(e) {
  var r = hi(this), n = r.prototype, a = wt(arguments, 1), o = function() {
    var s = _i(a, wt(arguments));
    return this instanceof o ? Si(r, s.length, s) : r.apply(e, s);
  };
  return gi(n) && (o.prototype = n), o;
}, wi = W, Tt = $i;
wi({ target: "Function", proto: !0, forced: Function.bind !== Tt }, {
  bind: Tt
});
var Ti = z, xi = Ti("Function").bind, Ei = K, ki = xi, Te = Function.prototype, Ii = function(t) {
  var e = t.bind;
  return t === Te || Ei(Te, t) && e === Te.bind ? ki : e;
}, Oi = Ii, Di = Oi, Ai = Di, xe = /* @__PURE__ */ ne(Ai), Pi = m, Ri = _, Fe = vr, Ci = Pi(Function.toString);
Ri(Fe.inspectSource) || (Fe.inspectSource = function(t) {
  return Ci(t);
});
var Ni = Fe.inspectSource, ji = m, Mi = $, Dr = _, Ui = xr, Fi = cr, Li = Ni, Ar = function() {
}, Bi = [], Pr = Fi("Reflect", "construct"), We = /^\s*(?:class|function)\b/, Vi = ji(We.exec), Gi = !We.exec(Ar), F = function(e) {
  if (!Dr(e)) return !1;
  try {
    return Pr(Ar, Bi, e), !0;
  } catch {
    return !1;
  }
}, Rr = function(e) {
  if (!Dr(e)) return !1;
  switch (Ui(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return Gi || !!Vi(We, Li(e));
  } catch {
    return !0;
  }
};
Rr.sham = !0;
!Pr || Mi(function() {
  var t;
  return F(F.call) || !F(Object) || !F(function() {
    t = !0;
  }) || t;
});
var Ki = U;
Ki("species");
var qi = yr, Hi = m, Wi = ar, zi = hr, Yi = $r, xt = Hi([].push), Ji = function(t) {
  return function(e, r, n, a) {
    for (var o = zi(e), i = Wi(o), s = qi(r, n), u = Yi(i), d = 0, v = void 0, f, l; u > d; d++)
      if (f = i[d], l = s(f, d, o), l) switch (t) {
        case 3:
          return !0;
        // some
        case 5:
          return f;
        // find
        case 6:
          return d;
        // findIndex
        case 2:
          xt(v, f);
      }
      else switch (t) {
        case 4:
          return !1;
        // every
        case 7:
          xt(v, f);
      }
    return v;
  };
}, Xi = {
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: Ji(5)
}, Zi = W, Qi = Xi.find, Et = "find", Cr = !0;
Et in [] && Array(1)[Et](function() {
  Cr = !1;
});
Zi({ target: "Array", proto: !0, forced: Cr }, {
  find: function(e) {
    return Qi(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var es = z, ts = es("Array").find, rs = K, ns = ts, Ee = Array.prototype, as = function(t) {
  var e = t.find;
  return t === Ee || rs(Ee, t) && e === Ee.find ? ns : e;
}, os = as, is = os, ss = is, cs = /* @__PURE__ */ ne(ss), us = W, Nr = Ge, ls = Sr, kt = Er, ds = wr, fs = oe, ps = kr, It = Nr("".startsWith), vs = Nr("".slice), hs = Math.min, gs = ps("startsWith");
us({ target: "String", proto: !0, forced: !gs }, {
  startsWith: function(e) {
    var r = kt(fs(this));
    ds(e);
    var n = ls(hs(arguments.length > 1 ? arguments[1] : void 0, r.length)), a = kt(e);
    return It ? It(r, a, n) : vs(r, n, n + a.length) === a;
  }
});
var ms = z, ys = ms("String").startsWith, _s = K, bs = ys, ke = String.prototype, Ss = function(t) {
  var e = t.startsWith;
  return typeof t == "string" || t === ke || _s(ke, t) && e === ke.startsWith ? bs : e;
}, $s = Ss, ws = $s, Ts = ws, xs = /* @__PURE__ */ ne(Ts);
function Ot(t) {
  t = t.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const r = new RegExp(`[\\?&]${t}=([^&#]*)`).exec(location.search);
  return r === null ? null : Es(r[1].replace(/\+/g, " "));
}
function Es(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    return console.warn(`Failed to decode param value '${t}'`), t;
  }
}
const jr = {
  backendDomain: "dixa:backend-domain"
};
function ks() {
  const t = Ot("staging") || Ot("backend-domain");
  if (t) {
    const e = /^\d+$/.test(t) ? `euw1.stag${t === "1" ? "" : t}.dixa.io` : t;
    return Os(e), e;
  }
  return null;
}
function Is() {
  var t;
  const e = cs(t = document.cookie.split("; ")).call(t, (r) => xs(r).call(r, `${jr.backendDomain}=`));
  return e ? decodeURIComponent(e.split("=")[1]) : null;
}
function Os(t) {
  document.cookie = `${jr.backendDomain}=${encodeURIComponent(t)}; path=/; max-age=31536000; SameSite=Lax`;
}
var Dt, Ie, At, Oe, Pt, De, Rt, Ct, Nt;
const x = {
  restApiUrl: "_dixa-rest-api-url",
  partnerIntegrationsApiUrl: "_dixa-partner-integrations-api-url",
  filesApiUrl: "_dixa-files-api-url",
  loginUrl: "_dixa-login-url",
  signUpUrl: "_dixa-sign-up-url",
  subdomain: "_dixa-subdomain",
  webSocketUrl: "_dixa-websocket-url"
}, Ae = window.location.origin.replace(/^https?:\/\//, ""), g = ks() ?? Is(), c = {
  // The development domains.
  develop: ["localhost:8080", "dixadev.com", "dixa.io"],
  // The testing domains.
  test: {
    // The security testing domains.
    security: ["dixa-security.com", "dixa-security.net"],
    // The automation testing domains.
    automation: ["localhost:9999", "test-agent-interface.dixa.io", "test.dixatest.com", "okta-test-org.dixatest.com"]
  },
  // The custom subdomains.
  custom: ["thehaddaway.dixa.com", "demo.dixa.com", "developer.dixa.com", "okta-test.dixa.com", "development.dixa.com", "engineering.dixa.com"],
  default: {
    email: "dixa.com",
    emailIntegration: "email.dixa.io",
    integrations: "docs.dixa.io",
    service: "dixa.io",
    status: "status.dixa.io",
    subdomain: localStorage.getItem(x.subdomain) ?? "demo",
    userContent: "dixausercontent.com",
    web: "dixa.com",
    accounts: "accounts.dixa.com",
    knowledge: "knowledge-backend-cdn"
  }
}, Ds = {
  assets: `https://assets.${c.default.service}`,
  toolkit: `https://toolkit.${c.default.service}`,
  widget: `https://widget.${c.default.service}`,
  rest: localStorage.getItem(x.restApiUrl) ?? `https://api.${g ?? c.default.service}`,
  partnerIntegrations: localStorage.getItem(x.partnerIntegrationsApiUrl) ?? `https://partner-integrations.${g ?? c.default.service}`,
  files: localStorage.getItem(x.filesApiUrl) ?? `https://files.${g ?? c.default.service}`,
  webSocket: localStorage.getItem(x.webSocketUrl) ?? `wss://agent-sockets.${g ?? c.default.service}/v2/agent/`,
  userContent: g ? `https://raw.${g.replace(c.default.service, c.default.userContent)}` : `https://raw.${c.default.userContent}`,
  signUp: localStorage.getItem(x.signUpUrl) ?? `https://${c.default.accounts}/signup`,
  logIn: localStorage.getItem(x.loginUrl) ?? `https://${c.default.accounts}/signin`,
  smartConversationReply: Le(g) === "prod" ? `https://knowledge-backend-cdn.${c.default.service}` : `https://knowledge-backend-cdn.stag.${c.default.service}`,
  dixaKnowledgeBackend: Le(g) === "prod" ? `https://knowledge-backend.${c.default.service}` : `https://knowledge-backend.stag.${c.default.service}`
}, As = {
  amplitude: {
    environment: A(Dt = [...c.test.automation, ...c.develop, ...c.test.security, ...c.custom]).call(Dt, Ae) || ((Ie = g) == null ? void 0 : xe(At = Function.call).call(At, A(Ie), Ie))?.(".stag") || ((Oe = g) == null ? void 0 : xe(Pt = Function.call).call(Pt, A(Oe), Oe))?.(".dev") || ((De = g) == null ? void 0 : xe(Rt = Function.call).call(Rt, A(De), De))?.(".preprod") ? "stag" : "prod"
  },
  launchDarkly: A(Ct = c.develop).call(Ct, Ae) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
  stripe: A(Nt = c.develop).call(Nt, Ae) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
  elevio: "599d54aacd7bd",
  birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
  jabra: {
    partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
    appId: "Dixa",
    appName: "Dixa"
  }
};
function Le(t) {
  const e = t?.match(/(preprod|dev\d?|stag\d?)/);
  return !e || e.length < 2 ? "prod" : e[1];
}
const B = {
  environment: Le(g),
  domain: c.default,
  sdk: As,
  url: Ds,
  backendDomain: g
};
class Ps {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const jt = new Ps();
function Rs(t, e) {
  return Mt(t), Mt(e), t.localeCompare(e, void 0, {
    numeric: !0
  });
}
function Mt(t) {
  if (t.split(".").length !== 3)
    throw Error(`The version '${t}' must be in the format 'x.x.x'.`);
}
const Cs = Object.prototype.toString;
function Ns(t, e) {
  return Cs.call(t) === `[object ${e}]`;
}
function js(t) {
  return Ns(t, "Object");
}
function Ms(t) {
  return !!(t && t.then && typeof t.then == "function");
}
const L = "8.36.0", S = globalThis;
function ze(t, e, r) {
  const n = r || S, a = n.__SENTRY__ = n.__SENTRY__ || {}, o = a[L] = a[L] || {};
  return o[t] || (o[t] = e());
}
const Mr = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Us = "Sentry Logger ", Ut = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Ft = {};
function Ur(t) {
  if (!("console" in S))
    return t();
  const e = S.console, r = {}, n = Object.keys(Ft);
  n.forEach((a) => {
    const o = Ft[a];
    r[a] = e[a], e[a] = o;
  });
  try {
    return t();
  } finally {
    n.forEach((a) => {
      e[a] = r[a];
    });
  }
}
function Fs() {
  let t = !1;
  const e = {
    enable: () => {
      t = !0;
    },
    disable: () => {
      t = !1;
    },
    isEnabled: () => t
  };
  return Mr ? Ut.forEach((r) => {
    e[r] = (...n) => {
      t && Ur(() => {
        S.console[r](`${Us}[${r}]:`, ...n);
      });
    };
  }) : Ut.forEach((r) => {
    e[r] = () => {
    };
  }), e;
}
const ee = ze("logger", Fs);
function Ls(t, e, r) {
  try {
    Object.defineProperty(t, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Mr && ee.log(`Failed to add non-enumerable property "${e}" to object`, t);
  }
}
const Fr = 1e3;
function Ye() {
  return Date.now() / Fr;
}
function Bs() {
  const { performance: t } = S;
  if (!t || !t.now)
    return Ye;
  const e = Date.now() - t.now(), r = t.timeOrigin == null ? e : t.timeOrigin;
  return () => (r + t.now()) / Fr;
}
const Vs = Bs();
(() => {
  const { performance: t } = S;
  if (!t || !t.now)
    return;
  const e = 3600 * 1e3, r = t.now(), n = Date.now(), a = t.timeOrigin ? Math.abs(t.timeOrigin + r - n) : e, o = a < e, i = t.timing && t.timing.navigationStart, u = typeof i == "number" ? Math.abs(i + r - n) : e, d = u < e;
  return o || d ? a <= u ? t.timeOrigin : i : n;
})();
function R() {
  const t = S, e = t.crypto || t.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (r = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (r() & 15) >> n / 4).toString(16)
    )
  );
}
function Lt() {
  return {
    traceId: R(),
    spanId: R().substring(16)
  };
}
function Je() {
  return Xe(S), S;
}
function Xe(t) {
  const e = t.__SENTRY__ = t.__SENTRY__ || {};
  return e.version = e.version || L, e[L] = e[L] || {};
}
function Gs(t, e = {}) {
  if (e.user && (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address), !t.did && !e.did && (t.did = e.user.id || e.user.email || e.user.username)), t.timestamp = e.timestamp || Vs(), e.abnormal_mechanism && (t.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration), e.sid && (t.sid = e.sid.length === 32 ? e.sid : R()), e.init !== void 0 && (t.init = e.init), !t.did && e.did && (t.did = `${e.did}`), typeof e.started == "number" && (t.started = e.started), t.ignoreDuration)
    t.duration = void 0;
  else if (typeof e.duration == "number")
    t.duration = e.duration;
  else {
    const r = t.timestamp - t.started;
    t.duration = r >= 0 ? r : 0;
  }
  e.release && (t.release = e.release), e.environment && (t.environment = e.environment), !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress), !t.userAgent && e.userAgent && (t.userAgent = e.userAgent), typeof e.errors == "number" && (t.errors = e.errors), e.status && (t.status = e.status);
}
const Be = "_sentrySpan";
function Bt(t, e) {
  e ? Ls(t, Be, e) : delete t[Be];
}
function Vt(t) {
  return t[Be];
}
const Ks = 100;
class Ze {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Lt();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new Ze();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e._lastEventId = this._lastEventId, Bt(e, Vt(this)), e;
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Gs(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, r) {
    return this._tags = { ...this._tags, [e]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, r) {
    return this._extra = { ...this._extra, [e]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, r) {
    return r === null ? delete this._contexts[e] : this._contexts[e] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const r = typeof e == "function" ? e(this) : e, [n, a] = r instanceof N ? [r.getScopeData(), r.getRequestSession()] : js(r) ? [e, e.requestSession] : [], { tags: o, extra: i, user: s, contexts: u, level: d, fingerprint: v = [], propagationContext: f } = n || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...u }, s && Object.keys(s).length && (this._user = s), d && (this._level = d), v.length && (this._fingerprint = v), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Bt(this, void 0), this._attachments = [], this._propagationContext = Lt(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, r) {
    const n = typeof r == "number" ? r : Ks;
    if (n <= 0)
      return this;
    const a = {
      timestamp: Ye(),
      ...e
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > n ? o.slice(-n) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Vt(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, r) {
    const n = r && r.event_id ? r.event_id : R();
    if (!this._client)
      return ee.warn("No client configured on scope - will not capture exception!"), n;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: a,
        ...r,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, r, n) {
    const a = n && n.event_id ? n.event_id : R();
    if (!this._client)
      return ee.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(e);
    return this._client.captureMessage(
      e,
      r,
      {
        originalException: e,
        syntheticException: o,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, r) {
    const n = r && r.event_id ? r.event_id : R();
    return this._client ? (this._client.captureEvent(e, { ...r, event_id: n }, this), n) : (ee.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
const N = Ze;
function qs() {
  return ze("defaultCurrentScope", () => new N());
}
function Hs() {
  return ze("defaultIsolationScope", () => new N());
}
class Ws {
  constructor(e, r) {
    let n;
    e ? n = e : n = new N();
    let a;
    r ? a = r : a = new N(), this._stack = [{ scope: n }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const r = this._pushScope();
    let n;
    try {
      n = e(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return Ms(n) ? n.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function j() {
  const t = Je(), e = Xe(t);
  return e.stack = e.stack || new Ws(qs(), Hs());
}
function zs(t) {
  return j().withScope(t);
}
function Ys(t, e) {
  const r = j();
  return r.withScope(() => (r.getStackTop().scope = t, e(t)));
}
function Gt(t) {
  return j().withScope(() => t(j().getIsolationScope()));
}
function Js() {
  return {
    withIsolationScope: Gt,
    withScope: zs,
    withSetScope: Ys,
    withSetIsolationScope: (t, e) => Gt(e),
    getCurrentScope: () => j().getScope(),
    getIsolationScope: () => j().getIsolationScope()
  };
}
function Lr(t) {
  const e = Xe(t);
  return e.acs ? e.acs : Js();
}
function Qe() {
  const t = Je();
  return Lr(t).getCurrentScope();
}
function Br() {
  const t = Je();
  return Lr(t).getIsolationScope();
}
function Xs() {
  return Qe().getClient();
}
function Zs(t) {
  if (t)
    return Qs(t) ? { captureContext: t } : tc(t) ? {
      captureContext: t
    } : t;
}
function Qs(t) {
  return t instanceof N || typeof t == "function";
}
const ec = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function tc(t) {
  return Object.keys(t).some((e) => ec.includes(e));
}
function Kt(t, e) {
  return Qe().captureException(t, Zs(e));
}
function rc(t, e) {
  const r = typeof e == "string" ? e : void 0, n = typeof e != "string" ? { captureContext: e } : void 0;
  return Qe().captureMessage(t, r, n);
}
function nc(t, e) {
  Br().setContext(t, e);
}
const ac = 100;
function E(t, e) {
  const r = Xs(), n = Br();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = ac } = r.getOptions();
  if (o <= 0) return;
  const s = { timestamp: Ye(), ...t }, u = a ? Ur(() => a(s, e)) : s;
  u !== null && (r.emit && r.emit("beforeAddBreadcrumb", u, e), n.addBreadcrumb(u, o));
}
var V;
(function(t) {
  t.Unknown = "unknown", t.Core = "core", t.Routing = "routing-and-presence", t.Insights = "insights", t.Ecosystem = "ecosystem", t.Partners = "partners", t.Channels = "channels", t.Messaging = "messaging", t.Platform = "platform", t.AI = "ai", t.Conversations = "conversations", t.Automation = "automation";
})(V || (V = {}));
function C(t) {
  const e = t.split(".")[1];
  if (!e)
    throw Error("Invalid token");
  const r = e.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (n) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${n}`);
  }
}
const oc = B.backendDomain ? {
  "backend-domain": B.backendDomain
} : void 0;
function te() {
  const t = new URLSearchParams({
    noToken: "true",
    ...oc
  }).toString();
  document.location.href = `${B.url.logIn}?${t}`;
}
const Pe = "authData", Re = 30, ic = 600, Ce = 5;
class sc {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const e = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Ce || this.clientServerTimeDiff <= -Ce ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(e) {
    this.authData = e;
    const n = Math.ceil(Date.now() / 1e3) + ic, a = C(e.access_token).exp;
    if (this.clientServerTimeDiff = a - n, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Ce) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Pe, JSON.stringify(e));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const e = localStorage.getItem(Pe), r = e ? JSON.parse(e) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Pe);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(e) {
    return e ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((n) => typeof e[n] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Re;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(e) {
    if (!e)
      return !0;
    const r = C(e), n = r.exp - Re;
    return !r || this.estimatedServerTime() >= n;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Re - this.estimatedServerTime()) * 1e3;
  }
}
const p = new sc();
async function cc(t) {
  const e = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!t.response || r.some((n) => e.includes(n)))) {
    try {
      const n = t.response.config.headers.Authorization ?? "", a = n ? n.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", i = o ? C(o).exp : "None", s = await et.getAuthData({ localStorageOnly: !0 }), u = Math.floor(Date.now() / 1e3), d = s?.access_token, v = s?.refresh_token, f = d ? C(d).exp : "None", l = v ? C(v).exp : "None", h = typeof i == "number" ? u - i : "Unknown", k = typeof f == "number" ? u - f : "Unknown", I = typeof l == "number" ? u - l : "Unknown", w = t.response.headers["x-dixa-rid"];
      nc("Expires", {
        currentTimestamp: u,
        accessTokenFromHeader: i,
        accessTokenFromHeaderDiff: h,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: k,
        refreshTokenFromLocalStorage: l,
        refreshTokenFromLocalStorageDiff: I,
        xDixaRid: w,
        navigatorOnline: navigator.onLine
      });
    } catch (n) {
      console.error("Error adding Sentry error context", n);
    }
    rc("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: V.Platform,
        domain: e
      }
    });
  }
}
const Ne = /* @__PURE__ */ new Map(), uc = 3;
function lc(t) {
  t.interceptors.response.use((e) => (Ne.delete(e.config.url), e), (e) => {
    if (e.response) {
      const { status: r } = e.response;
      switch (r) {
        case Ve.Unauthorized:
          if (!et.isRefreshTokenExpired() && e.config) {
            E({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const n = Ne.get(e.config.url) ?? 0;
            if (console.log(`Retrying request (${n + 1}): ${e.config.url}`), n <= uc)
              return Ne.set(e.config.url, n + 1), t(e.config);
          }
          cc(e), console.error("401 unauthorized interceptor"), te();
          break;
      }
    }
    return Promise.reject(e);
  });
}
const Vr = Ht.create();
lc(Vr);
const b = console.log;
async function qt(t) {
  return new Promise((e) => setTimeout(e, t * 1e3));
}
class dc extends Error {
  constructor(e, r) {
    super(e, r);
  }
}
function fc(t = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, t)), 30);
}
const pc = 5;
class vc {
  authDataPromise = null;
  retryCount = 0;
  async init(e) {
    const r = await this.refresh(e);
    if (r)
      p.setAuthData(r);
    else {
      const n = p.isRefreshTokenExpired(e) ? "expired" : "unknown";
      throw new dc("Failed to init refresh token", {
        cause: n
      });
    }
  }
  getDebugInfo() {
    const e = p.getAccessToken();
    if (!e)
      return {};
    const r = C(e), { exp: n } = r;
    return {
      expire: n ? new Date(n * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: e = !1 } = {}) {
    if (e)
      return p.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = p.getAuthData();
    return r ? p.isAccessTokenExpired() ? (E({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((n) => (n && p.setAuthData(n), this.authDataPromise = null, n)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return p.removeAuthData();
  }
  validateAuthDataComplete(e) {
    return p.validateAuthDataComplete(e);
  }
  isAccessTokenExpired() {
    return p.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const e = p.getAuthData();
    return e ? p.isRefreshTokenExpired(e.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!jt.isElectron())
      return !0;
    const e = await jt.getVersion();
    return Rs(e, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(e, r = pc) {
    try {
      return await Vr.post(`${B.url.rest}/v2/login/refresh`, {
        refreshToken: e
      }).then((n) => (this.retryCount = 0, n.data.data));
    } catch (n) {
      return await this.handleRefreshError(n, e, r);
    }
  }
  async waitUntilOnline() {
    const e = navigator.onLine === !1;
    for (e && (b("AUTH", "Network connection offline - waiting..."), E({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await qt(5);
    e && (b("AUTH", "Network connection restored"), E({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(e, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const n = fc(this.retryCount);
    return b("AUTH", `Retrying in ${n} seconds`), await qt(n), await this.refresh(e, r);
  }
  async handleRefreshError(e, r, n) {
    if (p.isRefreshTokenExpired(r))
      return b("AUTH", "Refresh token expired"), E({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), p.removeAuthData(), te(), null;
    if (Gr(e)) {
      if (e.message === "timeout exceeded")
        return b("AUTH", "Timeout exceeded"), E({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, n);
      if (e.message === "Network Error")
        return b("AUTH", "Network error"), E({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, n);
      if (e.response?.status === 401)
        return b("AUTH", "Refresh token invalid (401)"), p.removeAuthData(), te(), null;
      Kt(e, {
        level: "error",
        tags: {
          team: V.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return n <= 0 ? (b("AUTH", "Retries exhausted, logging out"), Kt(e, {
      level: "error",
      tags: {
        team: V.Platform,
        errorSource: "authManager.refresh"
      }
    }), p.removeAuthData(), te(), null) : (b("AUTH", `Retrying ${n} more times`), await this.retryRefresh(r, n - 1));
  }
  accessTokenExpiresInMs() {
    return p.accessTokenExpiresInMs();
  }
}
const et = new vc();
var Ve;
(function(t) {
  t[t.BadRequest = 400] = "BadRequest", t[t.Unauthorized = 401] = "Unauthorized", t[t.Forbidden = 403] = "Forbidden", t[t.NotFound = 404] = "NotFound", t[t.Conflict = 409] = "Conflict", t[t.InternalServerError = 500] = "InternalServerError", t[t.BadGateway = 502] = "BadGateway", t[t.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Ve || (Ve = {}));
const hc = Ht.create();
class gc {
  /** The current logged in user. */
  user = null;
  /** The list of authorization scopes assigned to the current user. */
  scopes = null;
  /** This list of user roles assigned to the current user */
  _roles = null;
  /** Checks if the service has been initialized. */
  get isInitialized() {
    return this.user !== null;
  }
  /** Initializes the access control service. */
  async init({
    user: e
  }) {
    this.user = e;
    const r = await this.introspectAccessToken();
    r && (this.scopes = r.scope, this._roles = r.roles);
  }
  /** Exposed read-only list of user roles assigned to the current user */
  get roles() {
    return this._roles;
  }
  /**
   * Checks if the current user has access to one or more scopes.
   *
   * @param scopes - The scope(s) to check.
   * @param options - The options to use when checking multiple scopes.
   * @param options.strategy - The strategy to use when checking multiple
   *   scopes. Can be "all" or "any".
   * @returns Whether or not the user has access to the scope(s).
   */
  hasAccess(e, r) {
    if (!this.isInitialized || this.scopes === null)
      return !1;
    if (Array.isArray(e)) {
      const { strategy: n = "all" } = r ?? {};
      return n === "all" ? e.every(this.hasScope) : e.some(this.hasScope);
    }
    return this.scopes.includes(e);
  }
  /** Checks if the user has a certain scope. */
  hasScope = (e) => this.scopes.includes(e);
  /**
   * Fetches the introspection data of the current access_token and stores it in
   * memory. This should be called only once on init.
   */
  async introspectAccessToken() {
    const e = await et.getAuthData({ localStorageOnly: !0 });
    if (!e) return null;
    try {
      return (await hc.post(
        `${B.url.rest}/v1/introspect`,
        {
          token: e.access_token
        },
        {
          transformResponse: (n) => {
            const a = JSON.parse(n);
            return {
              ...a,
              /**
               * As per the spec, the backend returns the `scope` as a
               * space-separated string. We convert it to an array of strings to
               * make it easier for us.
               *
               * @see https://datatracker.ietf.org/doc/html/rfc7662#section-2.2
               */
              scope: a.scope ? a.scope.split(" ") : []
            };
          }
        }
      )).data;
    } catch {
      return null;
    }
  }
  reset() {
    this.user = null, this.scopes = null, this._roles = null;
  }
}
const mc = new gc(), bc = (t, e) => Kr(
  () => mc.hasAccess(t, e),
  // The arguments are statically defined when consuming the hook, therefore we don't need to
  // recompute the result on every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
);
export {
  mc as accessControl,
  bc as useHasAccess
};
//# sourceMappingURL=index.js.map
